import React from 'react'

import Logo1 from "../../../assets/TimeLineLogo/Logo1.svg"
import Logo2 from "../../../assets/TimeLineLogo/Logo2.svg"
import Logo3 from "../../../assets/TimeLineLogo/Logo3.svg"
import Logo4 from "../../../assets/TimeLineLogo/Logo4.svg"
import timelineImage from "../../../assets/Images/TimelineImage.png"

const timeline = [
    {
        Logo: Logo1,
        heading: "Leadership",
        Description: "Fully committed to the success company",
    },
    {
        Logo: Logo2,
        heading: "Leadership",
        Description: "Fully committed to the success company",
    },
    {
        Logo: Logo3,
        heading: "Leadership",
        Description: "Fully committed to the success company",
    },
    {
        Logo: Logo4,
        heading: "Leadership",
        Description: "Fully committed to the success company",
    },
];

function TimelineSection() {
    return (
        <div className=''>
            <div className='flex lg:flex-row gap-15 items-center justify-betwee mt-7 flex-col'>
                <div className='min-w-[45%] lg:w-[45%] flex flex-col gap-10 relative'>
                    <div className='absolute rotate-90 border-[1px] border-t-blue-400 -z-0 border-dotted h-[1px] w-[300px] -left-[125px] top-40'>

                    </div>
                    {
                        timeline.map((element, index) => {
                            return (
                                <div className='flex flex-row gap-6' key={index}>
                                    <div className='w-[50px] h-[50px] bg-white rounded-full flex items-center justify-center'>
                                        <img src={element.Logo}></img>
                                    </div>

                                    <div>
                                        <h2 className='font-semibold text-[18px]'>{element.heading}</h2>
                                        <p className='text-base'>{element.Description}</p>
                                    </div>

                                </div>

                            )
                        })
                    }

                </div>

                <div className='relative shadow-blue-200 mt-7 '>

                    <div className=' absolute shadow-2xl shadow-blue-300 top-10 left-10 -z-10 w-[100%] h-[100%]  bg-richblack-100  '>


                    </div>
                    <img  src={timelineImage}
                        alt="timelineImage"
                        className='shadow-white object-cover h-fit  '
                    />
                    <div className='absolute bg-caribbeangreen-700 flex flex-col gap-10 lg:flex-row text-white uppercase py-7
                     left-[50%] translate-x-[-30%] translate-y-[-110%]  lg:translate-x-[-50%] lg:translate-y-[-50%]'>
                        <div className='flex flex-row gap-5 items-center border-r border-caribbeangreen-300 px-7'>
                            <p className='text-3xl font-bold'>10</p>
                            <p className='text-caribbeangreen-300 text-sm'>Years of Experience</p>
                        </div>

                        <div className='flex gap-5 items-center px-7'>
                            <p className='text-3xl font-bold'>250</p>
                            <p className='text-caribbeangreen-300 text-sm'>TYpe of Courses</p>
                        </div>

                    </div>

                </div>

            </div>

        </div>
    )
}

export default TimelineSection